import React from 'react';
import type { RezaPortalInfo } from '@gov-nx/api';
import { MarkdownRender } from '@gov-nx/component/web';
import { useRezaLocale } from '@gov-nx/module/page';
import { Dialog, LayoutGap } from '@gov-nx/ui/web';
import type { IUseBoolean } from '@gov-nx/utils/common';
import { PortalInfoButton } from './PortalInfo';

interface Props {
	isEditModalOpen: IUseBoolean;
	portalInfo: RezaPortalInfo;
}

export const InvalidationModal = ({ isEditModalOpen, portalInfo }: Props) => {
	const { t } = useRezaLocale();

	return (
		<Dialog
			isOpen={isEditModalOpen.isTrue}
			onClose={isEditModalOpen.setFalse}
			title={<h3>{t('invalidation.title')}</h3>}
			footer={<PortalInfoButton portalInfo={portalInfo} />}>
			<LayoutGap>
				<MarkdownRender>{t('invalidation.description')}</MarkdownRender>
			</LayoutGap>
		</Dialog>
	);
};
